import * as React from 'react';
import styled, { css } from 'styled-components';
import { Text } from '@amzn/storm-ui';
import { AccountLabel } from './AccountLabel';
import { Account } from '@amzn/aac-chrome-internal-api';

const contentsContainerMixin = css`
  &&& {
    margin: 0 0 2px 0;
    color: ${({ theme }) => theme.palette.black};
    text-decoration: none;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 11px 18px;
    outline: revert;
    text-align: start;
  }
`;

export const AdvertisingAccountLink = styled.a`
  ${contentsContainerMixin}
`;

export const AdvertisingAccountContainer = styled.div`
  ${contentsContainerMixin}
`;

export const AdvertisingAccountMarketplaceName = styled(Text)`
  color: ${({ theme }) => theme.palette.boulder};
`;

export const IA2AdvertisingAccountItem: React.FC<{
  advertisingAccount: Account;
  countryLabel: string;
  isSelected: boolean;
}> = ({ advertisingAccount, countryLabel, isSelected }) => {
  const contents = (
    <span>
      <AccountLabel label={advertisingAccount.label} />
      {countryLabel && (
        <AdvertisingAccountMarketplaceName fontSize="mini">
          {countryLabel}
        </AdvertisingAccountMarketplaceName>
      )}
    </span>
  );

  if (isSelected) {
    return (
      <AdvertisingAccountContainer>{contents}</AdvertisingAccountContainer>
    );
  }

  return (
    <AdvertisingAccountLink
      data-ccx-e2e-id="aac-account-link"
      href={advertisingAccount.url}
      draggable="false"
    >
      {contents}
    </AdvertisingAccountLink>
  );
};
